module.exports = "images/blue.36c0c6b528c2f7a77abafebdb4996172.png";